import React from 'react';

const CustomPagination = ({ page, setPage, rowsPerPage, setRowsPerPage, totalRows, moh = false }) => {
    const totalPages = Math.ceil(totalRows / rowsPerPage);

    // Helper function to generate page numbers with ellipsis
    const getPageNumbers = () => {
        if (totalPages <= 7) {
            // Show all pages if total pages are 7 or less
            return Array.from({ length: totalPages }, (_, i) => i + 1);
        }

        const leftSide = [1, 2, 3];
        const rightSide = [totalPages - 2, totalPages - 1, totalPages];

        if (page <= 4) {
            return [...leftSide, '...', ...rightSide];
        }

        if (page >= totalPages - 3) {
            return [...leftSide, '...', ...rightSide];
        }

        return [...leftSide, '...', page, '...', ...rightSide];
    };

    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
        setPage(1); // Reset to first page
    };

    return (
        <div className="flex flex-col sm:flex-row items-center justify-between py-4 bg-[white] pr-[16px] pl-[16px]">
            {/* Page info */}
            <div className="flex items-center space-x-2 sm:space-x-4 mt-2 sm:mt-0">
                <span className="font-inter font-normal text-[16px] leading-[20px] tracking-[-0.006em] text-[#525866]">
                    Page {page} of {totalPages}
                </span>
            </div>

            {/* Pagination Controls */}
            <div className="flex items-center space-x-2 sm:space-x-4 mt-2 sm:mt-0">
                {/* First Page */}
                <button
                    onClick={() => setPage(1)}
                    disabled={page === 1}
                    className="p-2 text-sm disabled:opacity-50"
                >
                    {'<<'}
                </button>

                {/* Previous Page */}
                <button
                    onClick={() => setPage(page - 1)}
                    disabled={page === 1}
                    className="p-2 text-sm disabled:opacity-50"
                >
                    {'<'}
                </button>

                {/* Page Numbers */}
                {getPageNumbers().map((pageNum, index) => (
                    <button
                        key={index}
                        onClick={() => typeof pageNum === 'number' && setPage(pageNum)}
                        disabled={pageNum === '...'}
                        className={`p-2 text-sm border w-[32px] rounded-md ${pageNum === page ? 'bg-[#F6F8FA] text-[#0A0D14]' : 'bg-white'
                            }`}
                    >
                        {pageNum}
                    </button>
                ))}

                {/* Next Page */}
                <button
                    onClick={() => setPage(page + 1)}
                    disabled={page === totalPages}
                    className="p-2 text-sm disabled:opacity-50"
                >
                    {'>'}
                </button>

                {/* Last Page */}
                <button
                    onClick={() => setPage(totalPages)}
                    disabled={page === totalPages}
                    className="p-2 text-sm disabled:opacity-50"
                >
                    {'>>'}
                </button>
            </div>

            {/* Rows per page selector */}
            <div className="flex items-center space-x-2 sm:space-x-4">
                <span className="text-sm">Rows per page:</span>
                <select
                    value={rowsPerPage}
                    onChange={(e) => handleRowsPerPageChange(Number(e.target.value))}
                    className="border-[#E2E4E9] rounded-md p-1 text-sm w-[120px] text-[16px]"
                >
                    {[2, 5, 10, 15, 20].map((size) => (
                        <option key={size} value={size}>
                            {size} / page
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default CustomPagination;
